import { Error as ErrorIcon } from '@mui/icons-material';

const ErrorOutline = (): JSX.Element => (
  <ErrorIcon fontSize="inherit" aria-label="Error:" aria-hidden="false" />
);

export default ErrorOutline;
